import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TaxpayerSubscriptionAlert: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.warning.main}`
  }
}))
